/* eslint-disable import/prefer-default-export */
export const draftRequestQueryKeys = {
  draftProviderOptionsListing: (draftId: string, freightModes: string, form?: "v1" | "v2") => [
    "draft-provider-options",
    "list",
    draftId,
    freightModes,
    form,
  ],
};
